/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import Button from '@material-ui/core/Button'

import NotificationIcon from '@/Icons/NotificationIcon'

import getErrorsFromResponse from '@/Form/Functions/getErrorsFromResponse'

import GlobalSearch from '@/GlobalSearch'

import Notifications from '@/Notifications'

import ECFrontSubmenu from '@Navigation/ECFrontSubmenu'
import ECAdminSubmenu from '@Navigation/ECAdminSubmenu'
import ECSubmenu      from '@Navigation/ECSubmenu'
import FrontHeader    from '@Navigation/FrontHeader'

import MenuItem from '@Pure/MenuItem'
import Image    from '@Pure/Image'
import Link     from '@Pure/Link'
import Logo     from '@Pure/Logo'

import bemit from '@function/bemit'

const EC_member_header =
{
	welcome:
	{
		url: '/accueil',
		label: 'Accueil'
	},

	catalog:
	{
		label: 'Catalogue',
		url: '/accueil/catalogue',

		sub_items:
		{
			new_content:
			{
				url: '/accueil/nouveautes',
				label: 'Nouveautés'
			},

			tickets:
			{
				url: '/accueil/catalogue',
				label: 'Billetteries'
			},

			holidays:
			{
				url: '/accueil/sejours-vacances',
				label: 'Séjours & vacances'
			},

			artists:
			{
				url: '/accueil/artistes',
				label: 'Artistes & festivals'
			}
		}
	},

	partners_admin:
	{
		label: 'Gérer mes fiches partenaire',
		url: '/espace-partenaires',

		partner: true
	},

	tutorials:
	{
		label: 'Tutoriels',
		url: '/accueil/mon-espace/tutoriels'
	}
};

const partner_header =
{
	welcome:
	{
		url: '/espace-partenaires',
		label: 'Mes fiches partenaire'
	}
};

const EC_header =
{
	welcome: EC_member_header.welcome,

	catalog: EC_member_header.catalog,

	EC_admin:
	{
		url: '/espace-administrable',
		label: 'Espace Administrable',

		sub_items:
		{
			users_list:
			{
				url: '/espace-administrable/utilisateurs',
				label: 'Liste des utilisateurs'
			},

			payment_shipping:
			{
				url: '/espace-administrable/configuration',
				label: 'Paiement et livraison',

				admin_users_only: false
			},

			EC_infos:
			{
				url: '/espace-administrable/informations-du-CE',
				label: 'Infos pratiques et logo',

				admin_users_only: false
			},

			color_theme:
			{
				url: '/espace-administrable/couleur',
				label: 'Thème de couleur',

				admin_users_only: false
			},

			registration_code:
			{
				url: '/espace-administrable/mon-code-CE',
				label: 'Code d\'inscription'
			},

			exchange:
			{
				url: '/espace-administrable/mes-documents-synergies',
				label: 'Mes documents Synergies'
			},

			reporting:
			{
				url: '/espace-administrable/reporting',
				label: 'Reporting',

				admin_users_only: false
			},

			blog_posts:
			{
				url: '/accueil/mon-espace/blog',
				label: 'Publiez vos infos & Actus',

				admin_users_only: false
			},

			new_meeting_record:
			{
				url: '/accueil/mon-espace/nouveau-compte-rendu-de-reunion',
				label: 'Déposer un PV de réunion',

				admin_users_only: false
			},

			tutorials:
			{
				label: 'Tutoriels admin',
				url: '/accueil/mon-espace/tutoriels',

				admin_users_only: false
			}
		}
	},

	admin_abondement:
	{
		url: '/admin-abondement',
		label: 'Gestion abondement',

		admin_users_only: false,

		sub_items:
		{
			product_abondement:
			{
				url: '/espace-administrable/abondements-produit',
				label: 'Abondement produit'
			},

			user_abondement:
			{
				url: '/espace-administrable/abondement-utilisateur',
				label: 'Abondement utilisateur'
			},

			abondement_status:
			{
				url: '/espace-administrable/abondement-CE',
				label: 'Suivi et export'
			}
		}
	}
};

const synergies_header =
{
	welcome:
	{
		url: '/dashboard',
		label: 'Accueil'
	},

	EC_admin:
	{
		url: '/gestion-des-CE',
		label: 'Gestion des CE',

		sub_items:
		{
			EC_list:
			{
				url: '/gestion-des-CE/les-CE',
				label: 'Liste des CE'
			},

			synergies_blog:
			{
				url: '/gestion-des-CE/blog',
				label: 'Blog Synergies'
			},

			legal_blog:
			{
				url: '/gestion-des-CE/blog-juridique',
				label: 'Blog Juridique'
			},

			ad_blog:
			{
				url: '/gestion-des-CE/blog-promos',
				label: 'Blog Promotion'
			},

			tutorials:
			{
				url: '/gestion-des-CE/tutoriels',
				label: 'Tutoriels youtube'
			},

			newsletter:
			{
				url: '/export-newsletter',
				label: 'Export des emails'
			},

			users:
			{
				url: '/gestion-des-CE/membres',
				label: 'Utilisateurs'
			},

			rgpd:
			{
				url: '/gestion-RGPD',
				label: 'Gestion RGPD'
			},

			sorewards_import:
			{
				url: '/import-sorewards',
				label: 'Import Sorewards'
			}
		}
	},

	catalog:
	{
		url: '/gestion-du-catalogue/',
		label: 'Catalogue',

		sub_items:
		{
			show_products:
			{
				url: '/gestion-du-catalogue/billets',
				label: 'Billetteries'
			},

			blog:
			{
				url: '/gestion-du-catalogue/categories',
				label: 'Catégories'
			},

			quotes:
			{
				url: '/gestion-du-catalogue/demandes-de-devis',
				label: 'Demandes de devis'
			},

			products_families:
			{
				url: '/gestion-du-catalogue/familles-de-produits',
				label: 'Familles de produits'
			},

			providers:
			{
				url: '/gestion-du-catalogue/fournisseurs',
				label: 'Fournisseurs'
			},

			partners:
			{
				url: '/partenaires',
				label: 'Partenaires'
			},

			themes_export:
			{
				url: '/gestion-du-catalogue/export-par-theme',
				label: 'Export par thème'
			}
		}
	},

	orders_admin:
	{
		url: '/gestion-des-commandes/',
		label: 'Commandes',

		sub_items:
		{
			orders:
			{
				url: '/gestion-des-commandes/commandes',
				label: 'Commandes'
			},

			show_orders:
			{
				url: '/gestion-des-commandes/billetterie-spectacle',
				label: 'Billetterie spectacle'
			},

			orders_reset:
			{
				url: '/gestion-des-commandes/reinitialiser',
				label: 'Réinitialiser une commande'
			},

			codes_grouped_dashboard:
			{
				url: '/gestion-des-commandes/codes-promo-groupes',
				label: 'QR Codes importés'
			},

			codes_import:
			{
				url: '/import-codes-promo',
				label: 'Import QR codes'
			},

			codes_example:
			{
				url: '/exemple-codes-promo',
				label: 'Exemple QR code'
			}
		}
	},

	billing:
	{
		url: '/comptabilite',
		label: 'Compta',

		sub_items:
		{
			credit_notes:
			{
				url: '/gestion-des-avoirs',
				label: 'Avoirs'
			},

			orders_export:
			{
				url: '/export-des-commandes',
				label: 'Export comptabilité'
			},

			bills:
			{
				url: '/gestion-des-factures',
				label: 'Factures'
			},

			TPE_import:
			{
				url: '/import-TPE',
				label: 'Import TPE'
			},

			payments:
			{
				url: '/gestion-des-reglements',
				label: 'Règlements'
			},

			services:
			{
				url: '/gestion-des-services',
				label: 'Services'
			},

			VPs:
			{
				url: '/gestion-des-ventes-privees',
				label: 'Ventes privées'
			}
		}
	},

	config:
	{
		url: '/configuration',
		label: 'Configuration',

		sub_items:
		{
			artists:
			{
				url: '/configuration/artistes',
				label: 'Artistes'
			},

			users_functions:
			{
				url: '/configuration/fonctions',
				label: 'Fonctions des utilisateurs'
			},

			places:
			{
				url: '/configuration/lieux',
				label: 'Lieux'
			},

			themes:
			{
				url: '/configuration/themes-principaux',
				label: 'Thèmes principaux'
			},

			positions:
			{
				url: '/configuration/placements',
				label: 'Placements'
			},

			publics:
			{
				url: '/configuration/publics',
				label: 'Publics'
			},

			show_themes:
			{
				url: '/configuration/themes',
				label: 'Thèmes de spectacles'
			},

			age_ranges:
			{
				url: '/configuration/tranches-d-ages',
				label: 'Tranches d\'age'
			},

			show_product_types:
			{
				url: '/configuration/types-de-billet',
				label: 'Types de billets'
			},

			national_brands:
			{
				url: '/configuration/enseignes-nationales',
				label: 'Enseignes nationales'
			},

			syner_quiz:
			{
				url: '/configuration/syner-quizz',
				label: 'Syner\'Quiz'
			}
		}
	}
};

const legal_writer_header =
{
	legal_blog:
	{
		url: '/gestion-des-CE/blog-juridique',
		label: 'Blog Juridique'
	}
};

const { app, qwest, numeral } = window;

export default class UserHeader extends Component
{
	state =
	{
		is__sub_menu_open: false,
		cart_items_count: 0,
		permissions: { title: 'not_auth', can_pay: false },
		open: false,
		notifs_open: false,

		notifications: []
	};

	sub_menu = { title: 'sub_menu' };

	componentDidMount ()
	{
		const component = this, props = this.props;

		app.push(
		{
			type: 'listener',
			event: 'documentClick',
			cb: component.handleDocumentClick
		});

		app.push(
		{
			event: 'cartChange',
			cb: component.handleCartChange
		});

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.state.abondement = { value: 0 };

		component.handleSessionChange();

		component.handleCartChange();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			type: 'listener',
			event: 'documentClick',
			cb: component.handleDocumentClick
		});

		app.delete(
		{
			event: 'cartChange',
			cb: component.handleCartChange
		});

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange = () =>
	{
		const component = this, props = this.props;

		component.setState(
		{
			permissions: app.state.session.permissions || { title: 'not_auth' },
			abondement: app.state.session.abondement || { value: 0 },
			user_abondement: app.state.session.user_abondement || { value: 0 }
		});

		const with_notifications = ['Administrateur de CE', 'Membre de CE', 'CE']
		.includes(app.state.session.permissions?.title);

		if (with_notifications)
		{
			component.getNotifications();
		}
	}

	getNotifications = () =>
	{
		const component = this, props = this.props, state = this.state;

		qwest.post('/notifications/get')
		.then(function (xhr, response)
		{
			const notifications = response.notifications || [];

			let unread_count = notifications.length > 0
			? parseInt(notifications.length)
			: 0;

			component.setState(
			{
				notifications: notifications,

				unread_notifications: unread_count > 0
				? String(unread_count)
				: '0'
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response,
					redirect: false
				})
			});
		});
	}

	readNotification = (e, notification) =>
	{
		const component = this, props = this.props, state = this.state;

		e?.stopPropagation();

		app.emit('documentClick', 'UserHeaderNotifications');

		qwest.post('/notifications/read',
		{
			patterns: [notification.type + '_' + notification.ressource_id]
		})
		.then(function (xhr, response)
		{
			const notifications = (state.notifications || [])
			.filter(function (state_notif)
			{
				if (state_notif.type === notification.type &&
					state_notif.ressource_id === notification.ressource_id)
				{
					return false;
				}

				return true;
			});

			const update =
			{
				notifications: notifications,

				unread_notifications: notifications.length > 0
				? (notifications.length > 99 ? '99' : String(notifications.length))
				: '0'
			};

			if (notifications.length === 0)
			{
				update.notifs_open = false;
			}

			component.setState(update);
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response
				})
			});
		});
	}

	handleCartChange = () =>
	{
		const component = this, props = this.props;

		let items_count = app.state.cart.reduce(function (total, item)
		{
			return Number(item.cart_qty) + total;
		}, 0);

		component.setState({ cart_items_count: items_count || 0 });
	}

	handleDocumentClick = (source) =>
	{
		const component = this, props = this.props, state = this.state;

		if (source === 'UserHeaderAbondement') return;

		if (source !== 'UserHeaderAbondement' && source !== 'NavbarToggle')
		{
			if (state.open !== false)
			{
				component.setState({ open: false });
			}
		}

		if (source !== 'UserHeaderAbondement' && source !== component.sub_menu)
		{
			if (state.is__sub_menu_open !== false)
			{
				component.setState(
				{
					is__sub_menu_open: false
				});
			}
		}

		if (['UserHeaderNotifications', 'NavbarNotifsToggle']
			.includes(source) === false)
		{
			if (state.notifs_open !== false)
			{
				component.setState({ notifs_open: false });
			}
		}
	}

	handleAbondementClick = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		e.persist();

		e.stopPropagation();

		app.emit('documentClick', 'UserHeaderAbondement');
	}

	toggleSubMenu = (e) =>
	{
		const component = this, props = this.props;

		e.stopPropagation();

		e.target.blur();

		app.emit('documentClick', component.sub_menu);

		component.setState(
		{
			is__sub_menu_open: !component.state.is__sub_menu_open
		});
	}

	logout = (e) =>
	{
		const component = this, props = this.props;

		e.preventDefault();

		qwest.post('/logout')
		.then(function (xhr, response)
		{
			app.initState();

			app.navigateTo(response.pathname + '?action=logout');
		});
	}

	handleToggle = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		e?.stopPropagation();

		app.emit('documentClick', 'NavbarToggle');

		component.setState({ open: !state.open });
	}

	toggleNotifications = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		e?.stopPropagation();

		app.emit('documentClick', 'NavbarNotifsToggle');

		component.setState({ notifs_open: !state.notifs_open });
	}

	captureNotifClick = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		e?.stopPropagation();

		app.emit('documentClick', 'UserHeaderNotifications');
	}

	render ()
	{
		const props = this.props, component = this, state = this.state;

		const is__mobile = window.innerWidth <= 767;

		const role = state.permissions.title || 'not_auth';

		const permissions = state.permissions || { }, open = state.open;

		const can_use_abondement = [true, 'true'].includes(permissions.abondement);

		let can_pay = [true, 'true'].includes(permissions.can_pay);
		let pay     = [true, 'true'].includes(permissions.pay);

		let header_config = EC_member_header;

		let submenu;

		if (role === 'Membre de CE')
		{
			submenu =
			(
				<ECFrontSubmenu open={ state.is__sub_menu_open }
					logout={ component.logout } { ...props }
					permissions={ permissions }
					abondement={ state.user_abondement?.value || 0 }
					can-use-abondement={ can_use_abondement }
					onAbondementClick={ component.handleAbondementClick }
					sorewards={ props.sorewards }
				/>
			);
		}
		else if (role === 'Administrateur de CE')
		{
			submenu =
			(
				<ECAdminSubmenu open={ state.is__sub_menu_open }
					logout={ component.logout } { ...props }
					permissions={ permissions }
					abondement={ state.user_abondement?.value || 0 }
					can-use-abondement={ can_use_abondement }
					onAbondementClick={ component.handleAbondementClick }
					sorewards={ props.sorewards }
				/>
			);
		}
		else if (role === 'EC')
		{
			header_config = EC_header;

			submenu =
			(
				<ECSubmenu open={ state.is__sub_menu_open }
					logout={ component.logout } { ...props }
					permissions={ permissions }
					abondement={ state.abondement?.value || 0 }
					can-use-abondement={ can_use_abondement }
					onAbondementClick={ component.handleAbondementClick }
				/>
			);
		}
		else if (role === 'Membre de synergies')
		{
			can_pay = false;
			pay = false;

			header_config = _.cloneDeep(synergies_header);

			const user_id = app.state?.session?.id;

			const has__billing =
			[
				'5a1eee36063802ce7eb2b39d', // panda
				'5a7352182f6c42dba1213ea3', // nath
				'5c90f0e1dad24c76c971aa5c', // marie
				'5a66082f464daed256b231ad' // marlene
			]
			.includes(user_id);

			if (!has__billing)
			{
				delete header_config.billing;

				['TPE_import', 'codes_import', 'codes_dashboard']
				.forEach(field => delete header_config.orders_admin.sub_items[field]);
			}

			submenu =
			(
				<div className={ bemit('c-sub-menu',
					state.is__sub_menu_open ? ['open'] : []) }>

					<ul className="c-sub-menu__menu">

						<MenuItem base_class="c-sub-menu__item" path="/login"
							history={ props.history }>
							<a href="/logout" className="c-sub-menu__link"
								onClick={ component.logout }>
								Déconnexion
							</a>
						</MenuItem>

						<MenuItem base_class="c-sub-menu__item" path="/"
							history={ props.history }>
							<Link href="/" className="c-sub-menu__link">
								Administration
							</Link>
						</MenuItem>

						<MenuItem base_class="c-sub-menu__item" path="/accueil"
							history={ props.history }>
							<Link href="/accueil" className="c-sub-menu__link">
								Front CE salariés
							</Link>
						</MenuItem>

					</ul>

				</div>
			);
		}
		else if (role === 'Partenaire')
		{
			can_pay = false;
			pay = false;

			header_config = partner_header;

			submenu =
			(
				<div className={ bemit('c-sub-menu',
					state.is__sub_menu_open ? ['open'] : []) }>

					<ul className="c-sub-menu__menu">

						<MenuItem base_class="c-sub-menu__item" path="/login"
							history={ props.history }>

							<a href="/logout" className="c-sub-menu__link"
								onClick={ component.logout }>
								Déconnexion
							</a>

						</MenuItem>

						<MenuItem base_class="c-sub-menu__item"
							path="/espace-partenaires"
							history={ props.history }>

							<Link href="/espace-partenaires"
								className="c-sub-menu__link">
								Gérer mes fiches partenaire
							</Link>

						</MenuItem>

					</ul>

				</div>
			);
		}
		else if (role === 'legal_writer')
		{
			can_pay = false;
			pay = false;

			header_config = legal_writer_header;

			submenu =
			(
				<div className={ 'c-sub-menu' +
					(state.is__sub_menu_open ? ' c-sub-menu--open' : '') }>

					<ul className="c-sub-menu__menu">

						<MenuItem base_class="c-sub-menu__item" path="/login"
							history={ props.history }>

							<a href="/logout" className="c-sub-menu__link"
								onClick={ component.logout }>
								Déconnexion
							</a>

						</MenuItem>
					</ul>

				</div>
			);
		}

		let cart;

		if (can_pay || pay)
		{
			cart =
			(
				<Link href="/panier" className="o-navbar__special-btn cart"
					data-items={ component.state.cart_items_count }>

					<svg className="o-svg-icon o-svg-icon--shopping-cart">
						<use xlinkHref="/images/icons.svg#svg-icon-shopping-cart" />
					</svg>

					<button type="button">
						Mon panier
					</button>

				</Link>
			);
		}

		let home_link = '/accueil';

		if (['Membre de synergies'].includes(permissions.title))
		{
			home_link = '/dashboard';
		}

		let admin_indicator;

		if (permissions.title === 'EC')
		{
			admin_indicator =
			(
				<div className="o-navbar__admin-indicator" />
			);
		}

		let logo;

		if (permissions.title !== 'Partenaire')
		{
			logo =
			(
				<Link href={ home_link } className="o-navbar__logo-link">
					<Logo className="o-navbar__logo" type="svg" />
				</Link>
			);
		}

		if ([true, 'true'].includes(permissions.access_partners) && is__mobile)
		{
			logo =
			(
				<Button type="button"
					className={ bemit('c-floating-card', ['link']) }
					href="/accueil/espace-partenaires/partenaires">
					<Image className="c-floating-card__icon"
						src="/images/carte_synergies_2026.png"
					/>
				</Button>
			);
		}

		const with_notifications = ['Administrateur de CE', 'Membre de CE', 'CE']
		.includes(permissions.title);

		let output =
		(
			<header className="page-header">

				<nav className={ bemit('o-navbar', open ? ['open'] : []) }
					id="navbar">

					<Button className="o-navbar__toggle u-no-select"
						onClick={ component.handleToggle }>
						<span className="o-navbar__toggle-label">Menu</span>
						<span className="o-navbar__toggle-bar" />
						<span className="o-navbar__toggle-bar" />
						<span className="o-navbar__toggle-bar" />
					</Button>

					{ logo }

					<FrontHeader links={ header_config } open={ open } />

					{
						['legal_writer', 'Partenaire'].includes(role) === false ?
						(
							<GlobalSearch />
						)
						: undefined
					}

					{ cart }

					{
						with_notifications ?
						(
							<Button className="o-navbar__notif-toggle u-no-select"
								onClick={ component.toggleNotifications }
								data-unread={ state.unread_notifications > 0
									? state.unread_notifications : undefined }>
								<NotificationIcon className="o-navbar__notif-icon" />
							</Button>
						)
						: undefined
					}

					{
						with_notifications ?
						(
							<Notifications open={ state.notifs_open === true }
								notifications={ state.notifications }
								onClick={ component.captureNotifClick }
								setRead={ component.readNotification }
							/>
						)
						: undefined
					}

					{ admin_indicator }

					<div className={ 'o-navbar__special-btn account' +
						(component.state.is__sub_menu_open
							? ' submenu-open' : '') }>

						<svg className="o-svg-icon o-svg-icon--account">
							<use xlinkHref="/images/icons.svg#svg-icon-account" />
						</svg>

						<button type="button" onClick={ component.toggleSubMenu }>
							Mon compte
						</button>

						{ submenu }

					</div>

				</nav>

			</header>
		);

		return output;
	}
}